import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import _ from 'lodash';

import { getBaseUrl } from 'services/util';
import HubspotFormConfigurations from "./hubspot";
import { toggleFormManageView } from 'actions/forms/forms';

import styles from '../forms.module.scss';
import MarketoFormConfigurations from './marketo';
import PardotFormConfigurations from './pardot';
import ExternalFormConfigurations from './external';

export default function FormConfigurations() {
  const dispatch = useDispatch();

  let { path, url } = useRouteMatch();
  const isFormManageView = useSelector(state => _.get(state, `forms.formManageView`, false));
  let baseUrl = getBaseUrl(url);
  const history = useHistory();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const integrationType = urlParams.get('type')

  const handleBackClick = () => {
    dispatch(toggleFormManageView(!isFormManageView))
    var url = `${baseUrl}/integration-settings/forms`;
    history.push(`${url}?type=${integrationType}`);
  }

  const renderConfigurations = () => {
    switch(integrationType) {
      case "hubspot": {
        return <HubspotFormConfigurations />
      }

      case "marketo": {
        return <MarketoFormConfigurations />
      }

      case "pardot": {
        return <PardotFormConfigurations />
      }

      case 'external': {
        return <ExternalFormConfigurations />
      }
    }
  }
  return (
    <div className={styles.formConfigurations}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>

      <div className={styles.formConfigurationHeading}>Form Configurations</div>
      {renderConfigurations()}
    </div>
  )
}